import React, { useContext } from 'react';
import { IWatchFullInfoContext, WatchFullInfoContext } from '../../../watchFullInfoState/watchFullInfoContext';
import Text from 'components/Text/Text';
import { EditBtn } from './EditBtn';
import style from './index.module.scss';

export const WatchFullInfoControlPanel: React.FC = () => {
	const { watchFullInfo } = useContext<IWatchFullInfoContext>(WatchFullInfoContext);

	return (
		<div className={style.container}>
			<div className={style.heading}>
				<Text
					className={style.headingText}
					translationKey={watchFullInfo?.serialNumber || null}
					size="xxl"
					weight="bold"
				/>
				<EditBtn />
			</div>
		</div>
	);
};
